import React from 'react'
import Footer from '../components/shared/Footer'
import Navbar from '../components/shared/Navbar'
import TestingEngineerBody from '../components/testingEngineer/TestingEngineerBody'

const TestingEngineer = () => {
  return (
    <div>
      <Navbar></Navbar>
      <TestingEngineerBody></TestingEngineerBody>
      <Footer></Footer>
    </div>
  )
}

export default TestingEngineer
